import React from 'react';

import './footer.styles.scss';

export default function Footer() {
  return (
    <footer className='footer-container'>
      <div className='footer-contents'>
        <div className='footer-left'>
          <a id='footer-left-nrcc' href='http://www.nrcc.cornell.edu/'>
            <div id='nrcc-cont'>
              <img
                id='nrcc'
                src={process.env.PUBLIC_URL + '/logos/nrcc.svg'}
                alt='Organization logo for the Northeast Regional Climate Center'
              />
            </div>
          </a>
          <a id='footer-left-usdn' href='https://www.usdn.org/index.html#/'>
            <div id='usdn-cont'>
              <img
                id='usdn'
                src={process.env.PUBLIC_URL + '/logos/usdn.png'}
                alt='Organization logo for the Urban Sustainability Directors Network'
              />
            </div>
          </a>
        </div>
        <div className='footer-center'>
          <p>
            This tool was co-produced by the{' '}
            <a href='https://www.usdn.org/index.html#/'>
              Urban Sustainability Directors Network
            </a>{' '}
            and the Carolina, Great Lakes and Mid-Atlantic Regional Integrated
            Sciences and Assessments (
            <a href='https://www.cisa.sc.edu/'>CISA</a>,{' '}
            <a href='https://glisa.umich.edu/'>GLISA</a>, and{' '}
            <a href='https://www.midatlanticrisa.org/'>MARISA</a>) Programs.
            Team members from MARISA are also affiliated with the National
            Oceanic and Atmospheric Administration (
            <a href='https://www.noaa.gov/'>NOAA</a>) Northeast Regional Climate
            Center (<a href='http://www.nrcc.cornell.edu/'>NRCC</a>).
          </p>
          <p>
            This effort was funded by the NOAA Climate Program Office (
            <a href='https://cpo.noaa.gov/'>CPO</a>).
          </p>
          <p>
            Version 2 of the CHaMP tool is currently active. It will be updated as the project team 
            continues to improve and enhance the tool’s functionality. Any comments or feedback on 
            the tool can be sent to <a href='mailto: CHaMP@rand.org'>CHaMP@rand.org</a>.
          </p>
        </div>
        <div className='footer-right'>
          <a id='footer-right-noaa' href='https://www.noaa.gov/'>
            <div id='noaa-cont'>
              <img
                id='noaa'
                src={process.env.PUBLIC_URL + '/logos/RISA_logo.png'}
                alt='Organization logo for the National Oceanic and Atmospheric Administration'
              />
            </div>
          </a>
        </div>
      </div>
    </footer>
  );
}
